import { z } from "zod";

export const UserLoginSchema = z.object({
  email: z.email(),
});

export type UserLoginValues = z.infer<typeof UserLoginSchema>;

export const defaultUserLoginValues: UserLoginValues = {
  email: "",
};
